import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { getTheme } from "@/lib/theme";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import DailyBrief from "@/pages/DailyBrief";
import EventsFeed from "@/pages/EventsFeed";
import EventDetail from "@/pages/EventDetail";
import ConfirmQueue from "@/pages/ConfirmQueue";
import Capture from "@/pages/Capture";
import Vendors from "@/pages/Vendors";
import VendorDetail from "@/pages/VendorDetail";
import Catalog from "@/pages/Catalog";
import Documents from "@/pages/Documents";
import Pricing from "@/pages/Pricing";
import Schemes from "@/pages/Schemes";
import PriceSearch from "@/pages/PriceSearch";

const Protected = () => {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen bg-slate-200 dark:bg-slate-950 flex items-center justify-center" data-testid="auth-loading-screen">
        <div className="h-8 w-8 rounded-full border-2 border-emerald-500 dark:border-emerald-500/60 border-t-transparent animate-spin" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" state={{ from: location }} replace />;
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

function App() {
  const [theme, setTheme] = useState(getTheme);
  useEffect(() => {
    const sync = () => setTheme(getTheme());
    window.addEventListener("shd-theme", sync);
    return () => window.removeEventListener("shd-theme", sync);
  }, []);
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route element={<Protected />}>
            <Route path="/" element={<DailyBrief />} />
            <Route path="/events" element={<EventsFeed />} />
            <Route path="/events/:id" element={<EventDetail />} />
            <Route path="/confirm" element={<ConfirmQueue />} />
            <Route path="/capture" element={<Capture />} />
            <Route path="/vendors" element={<Vendors />} />
            <Route path="/vendors/:id" element={<VendorDetail />} />
            <Route path="/catalog" element={<Catalog />} />
            <Route path="/library" element={<Documents />} />
            <Route path="/search" element={<PriceSearch />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/schemes" element={<Schemes />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" theme={theme} richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
